<template>
  <div v-show="isLoading">
    <LoadingOverlay :show="isLoading" title="Caricamento in corso..." :message="loadingMessage" />
  </div>

  <div class="top-bar-consultazione">
    Pareri in evidenza
  </div>

  <div class="question-list p-4">


    <div class="helpdesk-intro mb-4">
      <p>
        Il Supporto Giuridico, del Servizio Contratti Pubblici, è un servizio pubblico e gratuito realizzato dal
        Ministero delle infrastrutture e dei trasporti, in collaborazione con la
        <a href="https://www.regioni.it/" target="_blank" rel="noopener">Conferenza delle Regioni</a> e delle
        Province autonome ed
        <a href="https://www.itaca.org/nuovosito/index.asp" target="_blank" rel="noopener">ITACA – Istituto per
          l’innovazione e trasparenza degli appalti e la compatibilità ambientale</a>,
        in attuazione dell’art.
        <a href="https://www.normattiva.it/atto/caricaDettaglioAtto?atto.dataPubblicazioneGazzetta=2023-03-31&atto.codiceRedazionale=23G00044&atto.articolo.numero=0&atto.articolo.sottoArticolo=1&atto.articolo.sottoArticolo1=0&qId=df928fb0-f2cb-4095-be17-5f898f44d125&tabID=0.6929650205240001&title=lbl.dettaglioAtto"
          target="_blank" rel="noopener">223</a> comma 10, del D.Lgs.
        <a href="https://www.normattiva.it/atto/caricaDettaglioAtto?atto.dataPubblicazioneGazzetta=2023-03-31&atto.codiceRedazionale=23G00044&atto.articolo.numero=0&atto.articolo.sottoArticolo=1&atto.articolo.sottoArticolo1=0&qId=7a3679a9-a314-4ab2-ae18-3287b8c162be&tabID=0.6929650205240001&title=lbl.dettaglioAtto"
          target="_blank" rel="noopener">36/2023</a> sulla base di uno specifico Protocollo d’intesa.
      </p>
    </div>


    <div class="highlighted-wrapper">
      <a v-for="q in items" :key="q.id" href="#" class="highlighted-item" @click.prevent="openDetail(q.id)">
        <div class="image">
          <img :src="iconSrc" width="213" height="160" />
        </div>

        <div class="info">
          <p class="heading">
            {{ q.object || ('Parere ' + q.id) }}
          </p>

          <div class="text">
            <p>{{ q.excerpt }}</p>
          </div>
        </div>
      </a>

      <div v-if="!isLoading && items.length === 0" class="empty">
        Nessun parere in evidenza.
      </div>
    </div>
  </div>
</template>

<script>
import LoadingModal from '../../partials/LoadingModal.vue';
import icon from '../../../assets/icon_consultazione.jpg';
import LoadingOverlay from '../../partials/LoadingOverlay.vue';


export default {
  name: 'PareriHighlighted',
  components: { LoadingModal, LoadingOverlay },
  data() {
    return {
      isLoading: true,
      items: [],
      iconSrc: icon//this.$root.baseURL + '/bootstrap-italia/img/icon_consultazione.png'
    };
  },
  methods: {
    openDetail(id) {
      this.$emit('change-view', 'ParereView', id);
    },
    async loadHighlighted() {
      this.isLoading = true;
      try {
        const baseUrl = this.$root.config.VITE_APP_BACKOFFICE_URL.replace(/\/api$/, '');
        const res = await fetch(`${baseUrl}/questions/pareri-highlighted`, {
          method: 'GET',
          headers: { 'Accept': 'application/json' }
        });

        if (!res.ok) {
          const txt = await res.text();
          console.error('Errore highlighted:', res.status, txt);
          this.items = [];
          return;
        }

        const json = await res.json();
        this.items = json.data || [];
      } finally {
        this.isLoading = false;
      }
    }
  },
  async mounted() {
    await this.loadHighlighted();
  }
};
</script>

<style scoped>
.highlighted-wrapper {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
}

.highlighted-item {
  display: grid;
  grid-template-columns: 213px 1fr;
  gap: 1rem;
  align-items: stretch;
  text-decoration: none;
  color: inherit;
  background: #fff;
  border-radius: 0.75rem;
  overflow: hidden;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.highlighted-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12);
}

.image {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f6f9ff;
}

.image img {
  object-fit: contain;
}

.info {
  padding: 1rem 1.2rem;
}

.heading {
  font-weight: 700;
  font-size: 1.1rem;
  color: #17324d;
  margin: 0 0 0.5rem 0;
}

.text p {
  margin: 0;
  color: #1f2d3d;
}

.empty {
  padding: 1rem;
  color: #5c6f82;
}

.top-bar-consultazione {
  width: 100vw;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.14) 0%, rgba(255, 255, 255, 0) 45%),
    linear-gradient(180deg, #2f86ff 0%, #0059b3 45%, #003a7a 100%);
  color: white;
  font-size: 2rem;
  font-weight: bold;
  text-align: left;
  padding: 6rem 4rem;
  padding-left: 20rem;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.helpdesk-intro {
  background-color: #f8f9fa;
  border-left: 4px solid #0d6efd;
  padding: 1rem 1.5rem;
  border-radius: 0.5rem;
  font-size: 0.95rem;
  color: #1f2d3d;
  line-height: 1.5;
}

.helpdesk-intro p+p {
  margin-top: 0.5rem;
}
</style>